<script src="../../../../../../faktura/IDOCXWeb/Content/Scripts/SignModule/sign-module.js"></script>
<template>
  <v-card class="elevation-12 mt-3 mx-1" :loading="loading">
    <v-toolbar color="primary" dark flat>
      {{ pageTitle }}
    </v-toolbar>

    <v-card-text v-if="isPostPackageGroupLoaded">
      <v-simple-table dense>
        <template v-slot:default>
          <thead>
          <tr>
            <th>№</th>
            <th>Идентификатор</th>
            <th>Количество писем</th>
            <th>Отделение</th>
            <th>Дата поступления</th>
            <th>Создатель</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="postPackage in displayPostPackages" :key="postPackage.id">
            <td>{{ postPackage.displayNumber }}</td>
            <td>
              <router-link :to="{name: 'post-package', params: {uid: postPackage.uid}}">{{
                  postPackage.uid
                }}
              </router-link>
            </td>
            <td></td>
            <td>{{
                postPackage.postIndex ? `${postPackage.postIndex.postCode} -
                            ${postPackage.postIndex.name}` : null
              }}
            </td>
            <td class="text-center">
              {{ postPackage.createdOn.format('DD.MM.YYYY') }}
              <br>
              {{ postPackage.createdOn.format('HH:mm:ss') }}
            </td>
            <td>{{ postPackage.account.name }}</td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>
    <v-card-actions>
      <v-spacer/>
      <v-btn color="warning" small @click="onReprintButtonClicked">Распечатать ещё раз</v-btn>
    </v-card-actions>
    <v-snackbar v-model="isPostPackagesLoadingFailed"
                :timeout="5000"
                :top="true"
                color="error"
    >
      Не удалось загрузить пост пакеты
    </v-snackbar>
    <v-snackbar v-model="isPostPackageGroupLoadingFailed"
                :timeout="5000"
                :top="true"
                color="error"
    >
      Не удалось загрузить сводный реестр
    </v-snackbar>
  </v-card>
</template>

<script>
import _ from "underscore";
import {
  LAYOUT_LOADING_START,
  LAYOUT_LOADING_STOP,
  LAYOUT_TITLE_CHANGED
} from "@/store/modules/layout/actions";
import PostPackageGroupService from "@/services/post.package.group.service";
import Mappers from "@/mappers";
import PrintJS from "print-js";

export default {
  name: "PostPackageGroupView",
  data() {
    return {
      postPackageGroup: null,
      postPackages: [],
      loading: false,
      isPostPackagesLoadingFailed: false,
      isPostPackageGroupLoadingFailed: false
    }
  },
  computed: {
    pageTitle() {
      let title = 'Сводный реестр'
      if (this.postPackageGroup)
        title = `${title} : ${this.postPackageGroup.uid}`

      return title
    },
    isPostPackageGroupLoaded() {
      return !!this.postPackageGroup
    },
    displayPostPackages() {
      let number = 1;
      return _.map(this.postPackages, m => {
        m.displayNumber = number++
        return m
      })
    }
  },
  methods: {
    loadPostPackageGroup() {
      this.loading = true;
      this.$store.dispatch(LAYOUT_LOADING_START)

      this.postPackageGroup = null
      const uid = this.$route.params.uid

      this.isPostPackageGroupLoadingFailed = false
      PostPackageGroupService.get(uid)
          .then(response => {
            this.postPackageGroup = Mappers.mapPostPackageGroup(response.data)
            this.setPageTitle()

            this.loadPostPackages()
          })
          .catch(() => {
            this.isPostPackageGroupLoadingFailed = true
          })
          .finally(() => {
            this.loading = false;
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    },
    loadPostPackages() {
      this.loading = true;
      this.$store.dispatch(LAYOUT_LOADING_START)
      this.isPostPackagesLoadingFailed = false

      PostPackageGroupService.getPostPackages(this.postPackageGroup.uid)
          .then(response => {
            this.postPackages = _.map(response.data, postPackageViewModel => {
              return Mappers.mapPostPackage(postPackageViewModel)
            })
          })
          .catch(() => {
            this.isPostPackagesLoadingFailed = true
          })
          .finally(() => {
            this.loading = false;
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    },
    setPageTitle() {
      this.$store.dispatch(LAYOUT_TITLE_CHANGED, this.pageTitle)
    },

    onReprintButtonClicked() {
      const path = PostPackageGroupService.getPdfPath(this.postPackageGroup)
      PrintJS({
        printable: path,
        type: 'pdf',
        showModal: true,
        modalMessage: 'Подождите, идет загрузка для печати'
      })
    }
  },
  created() {
    this.setPageTitle()
    this.loadPostPackageGroup()
  },
  watch: {
    "$route": function () {
      this.loadPostPackageGroup()
    }
  },
}
</script>

<style scoped>

</style>